export default __webpack_public_path__ + "static/media/gall1.394a98e9.png";